import { clsx } from "clsx";
import { SVGIconProps } from "../interface";
const iconSize: Record<string, string> = {
  8: "h-2",
  12: "h-3",
  16: "h-4",
  24: "h-6",
  32: "h-8",
  40: "h-10",
  48: "h-12",
  56: "h-14",
  80: "h-20",
  124: "h-30",
};
const SvgSofaV2 = ({ title, titleId, size = 16, className }: SVGIconProps) => {
  const sizeClass = iconSize[size];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 21"
      width={size}
      height={size}
      className={clsx(sizeClass, className)}
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M1.98 19.665a.54.54 0 0 1 .54-.54h1.946a.54.54 0 1 1 0 1.08H2.52a.54.54 0 0 1-.54-.54M17.756 19.665a.54.54 0 0 1 .54-.54h1.945a.54.54 0 1 1 0 1.08h-1.944a.54.54 0 0 1-.54-.54" />
      <path
        fillRule="evenodd"
        d="M0 9.407a2.953 2.953 0 0 1 5.906 0v2.017h10.95V9.407a2.953 2.953 0 0 1 5.906 0v5.943a2.845 2.845 0 0 1-2.845 2.845H2.845A2.845 2.845 0 0 1 0 15.35zm2.953-1.153c-.637 0-1.153.516-1.153 1.153v5.943c0 .577.468 1.045 1.045 1.045h17.072c.577 0 1.045-.468 1.045-1.045V9.407a1.153 1.153 0 1 0-2.306 0v2.317a1.5 1.5 0 0 1-1.5 1.5H5.606a1.5 1.5 0 0 1-1.5-1.5V9.407c0-.637-.516-1.153-1.153-1.153"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M3.853 3.277c0-.816.662-1.477 1.477-1.477h12.318c.816 0 1.477.661 1.477 1.477v3.9h1.8v-3.9A3.277 3.277 0 0 0 17.648 0H5.33a3.277 3.277 0 0 0-3.277 3.277v3.9h1.8z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSofaV2;
